import { _authStore } from './store/auth-store';

export const auth = () => {
  // const { setToken, setIsAuthenticating, setIsAuthenticated } = _authStore.getState();

  return {
    ..._authStore.getState(),
    subscribe: _authStore.subscribe,
  };
};
